module.exports = __webpack_public_path__ + "img/ua.0b9acead.jpg";